module.exports = __webpack_public_path__ + "img/philips_heartstart-MRx-white.4e4eeba6.png";